import React, { Component, useCallback } from 'react'
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import axios from 'axios';
import Select from 'react-select';
// import * as FileSaver from 'file-saver';
// import * as XLSX from 'xlsx';
import jsPDF from "jspdf";
import "jspdf-autotable";
import URLImported from '../../common/api';
import Spinner from 'react-bootstrap/Spinner';
import ImportedURL from '../../common/api';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Capitalize } from '../../common/validate';


const loaderStyle = {
    textAlign: 'center',
    position: 'absolute',
    zIndex: 1,
    top: '120px',
    left: '46%'
};

class ListHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalType: "Add",
            columnDefs: [
                // { headerName: '#', valueGetter: "node.rowIndex+1", hide: true, width: 10, sortable: false, cellStyle: { 'text-align': 'center' }, hide: 'true' },
                {
                    headerName: 'URL', field: 'url', width: 250,
                    cellRenderer: function (params) {
                        return `<a href=//${params.value} target="_blank" style='color: #be7b08'>${params.value}</a>`;
                    }
                },
                { headerName: 'IP Address', field: 'ip', },
                { headerName: 'City', field: 'city', },
                { headerName: 'State', field: 'state', },
                { headerName: 'Post Code', field: 'postal', cellStyle: { 'text-align': 'center' } },
                {
                    headerName: 'Date & Time', field: 'datetime', cellStyle: { 'text-align': 'center' },
                    cellRenderer: function (params) {
                        if (params.data.datetime) {
                            return params.data.datetime;
                        }
                    }
                },
                { headerName: 'Country', field: 'country', cellStyle: { 'text-align': 'center' } },
            ],
            defaultColumDef: {
                // "width": 200,
                // "filter": true,
                // "sortable": false,
                // "resizable": true
                editable: false,
                sortable: true,
                resizable: true,
                filter: true,
                flex: 1,
                minWidth: 100,
            },
            uniqueUrl: [],
            uniqueCity: [],
            uniqueState: [],
            uniqueCountry: [],
            orignalData: [],
            historyData: [],
            name: '',
            country: '',
            state: '',
            city: '',
            selectedCountry: [],
            selectedState: [],
            selectedCity: [],
            counts: 0,
            spinner: true,
            searchhotel: '',
            searchhoteloption: '',
            hotelName: '',
            hideReset: false,

        }
    }

    onGridReady = (params) => {
        this.gridColumnApi = params.columnApi;
        this.gridApi = params.api;
        this.gridApi.sizeColumnsToFit();
    }

    exportToCSV = () => {
        const account = this.props.AccountState.account;
        this.gridApi.exportDataAsCsv({
            columnKeys: this.generateColumnsForExcel(),
            fileName: "bookingcount" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".csv",
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }

    generateColumnsForExcel() {
        const keys = this.gridColumnApi
            .getAllDisplayedColumns()
            .map(column => column.getColId())
        return keys;
    }

    // exportToCSV = () => {
    //     const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //     const fileExtension = '.xlsx';
    //     const ws = XLSX.utils.json_to_sheet(this.state.historyData);
    //     const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    //     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    //     const data = new Blob([excelBuffer], { type: fileType });
    //     const url = URL.createObjectURL(data);
    //     window.open(url, '_blank');
    //     FileSaver.saveAs(data, 'fileName' + fileExtension);
    // }
    exportPDF = () => {
        const account = this.props.AccountState.account;
        var dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + ' ' + (account.timeformat != '' ? account.timeformat : "hh:mm A")
        var tzone = 'America/chicago'
        if (account != undefined && account && account.tzone != undefined && account.tzone) {
            tzone = account.tzone
        }
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape
        const marginLeft = 15;
        var img = new Image();
        img.src = '../../assets/images/logo.png';
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);
        var hotelName = this.state.hotelName ? Capitalize(this.state.hotelName.split('.')[1]) : '';
        const title = (hotelName) ? (hotelName != "All" ? hotelName + " - Booking Count List" : "Booking Count List") : "Booking Count List";
        const headers = [["URL", "IP Address", 'City', 'State', 'Postal', "Date & Time", "Country"]];
        const data = this.state.historyData.map(elt => {
            return [
                elt.url,
                elt.ip,
                elt.city,
                elt.state,
                elt.postal,
                moment(elt.datetime).tz(tzone).format(dtFormat),
                elt.country,
            ]
        });
        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                minCellHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10,
                bottom: 70,
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120);
        doc.text('MyHotel AI', 710, 40)
        doc.autoTable(content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            const fullText = 'This is an auto-generated report from MyHotel AI (www.myhotelai.com)';
            const coloredText = '(www.myhotelai.com)';
            const textColor = [28, 48, 120]; // Specify your desired text color as an RGB array

            const textXPosition = 20;
            const textYPosition = 575;

            // Calculate the width of the full text before the colored text
            const fullTextWidth = doc.getTextWidth(fullText);
            const coloredTextWidth = doc.getTextWidth(coloredText);
            const leadingText = fullText.slice(0, fullText.indexOf(coloredText));

            // Render the leading text with default color
            doc.setTextColor(110); // Set default text color
            doc.text(leadingText, textXPosition, textYPosition);

            // Render the colored text with the specified color
            doc.setTextColor(textColor[0], textColor[1], textColor[2]);
            doc.text(coloredText, textXPosition + fullTextWidth - coloredTextWidth, textYPosition);
        }
        doc.save("bookingcount" + "_" + (hotelName && (hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf")
    }

    handleChange = e => {
        const { name, value, label } = e;
        this.onChange(e);
        if (name == "hotel") {
            this.setState({ searchhoteloption: e, searchhotel: value, hotelName: label, hideReset: true })
        }
        if (name == "country") {
            this.setState({ searchcountryoption: e, searchcountry: value, country: label, hideReset: true })
        }
        if (name == "state") {
            this.setState({ searchstateoption: e, searchstate: value, state: label, hideReset: true })
        }
        if (name == "city") {
            this.setState({ searchcityoption: e, searchcity: value, city: label, hideReset: true })
        }
    }
    onChange = e => {
        const { name, value } = e;
        this.gridApi.paginationGoToPage(0);
        // e.preventDefault();
        // let dumpData = [...this.state.historyData];
        let dumpData = [...this.state.orignalData];
        const regex = new RegExp(value, 'i');
        var filtered = "";
        if (name === 'hotel') {
            filtered = dumpData.filter(function (datum) {
                return (datum.url.search(regex) > -1);
            });
            const country = [];
            const uniqueUrl = [];
            const uniqueCity = [];
            const uniqueCountry = [];
            const uniqueState = [];
            filtered.map(history => {
                if (country.indexOf(history.country) === -1) {
                    country.push(history.country);
                }
                if (uniqueUrl.indexOf(history.url) === -1) {
                    uniqueUrl.push(history.url);
                }
                if (uniqueCity.indexOf(history.city) === -1) {
                    uniqueCity.push(history.city);
                }
                if (uniqueCountry.indexOf(history.country) === -1) {
                    uniqueCountry.push(history.country);
                }
                if (uniqueState.indexOf(history.state) === -1) {
                    uniqueState.push(history.state);
                }
            })
            this.setState({ hideReset: true, hotel: "" })

            this.setState({
                name: value,
                selectedCountry: country,
                state: '',
                city: '',
                country: '',
                counts: filtered.length,
                urlcount: uniqueUrl.length,
                citycount: uniqueCity.length,
                countrycount: uniqueCountry.length,
                statecount: uniqueState.length,
            })
        }
        if (name === 'country') {
            const hotelregex = new RegExp(this.state.name, 'i');
            filtered = dumpData.filter(function (datum) {
                return (datum.url.search(hotelregex) > -1);
            });
            filtered = filtered.filter(function (datum) {
                return (datum.country.search(regex) > -1);
            });
            const state = [];
            filtered.map(history => {
                if (state.indexOf(history.state) === -1) {
                    state.push(history.state);
                }
            })
            this.setState({ country: value, selectedState: state, city: '', state: '', hideReset: true })
        }
        if (name === 'state') {
            const hotelregex = new RegExp(this.state.name, 'i');
            const countryregex = new RegExp(this.state.country, 'i');
            filtered = dumpData.filter(function (datum) {
                return (datum.url.search(hotelregex) > -1);
            });
            filtered = filtered.filter(function (datum) {
                return (datum.country.search(countryregex) > -1);
            });
            filtered = filtered.filter(function (datum) {
                return (datum.state.search(regex) > -1);
            });
            const city = [];
            filtered.map(history => {
                if (city.indexOf(history.city) === -1) {
                    city.push(history.city);
                }
            })
            this.setState({ state: value, selectedCity: city, city: '', hideReset: true })
        }
        if (name === 'city') {
            const hotelregex = new RegExp(this.state.name, 'i');
            const countryregex = new RegExp(this.state.country, 'i');
            const stateregex = new RegExp(this.state.state, 'i');
            filtered = dumpData.filter(function (datum) {
                return (datum.url.search(hotelregex) > -1);
            });
            filtered = filtered.filter(function (datum) {
                return (datum.country.search(countryregex) > -1);
            });
            filtered = filtered.filter(function (datum) {
                return (datum.state.search(stateregex) > -1);
            });
            filtered = filtered.filter(function (datum) {
                return (datum.city.search(regex) > -1);
            });
            this.setState({ city: value })
        }
        this.setState({
            historyData: filtered, fromDate: '', toDate: '', hideReset: true
        });
    }

    setDate = (e) => {
        // ed = new Date("2016-08-21T00:00:00.000Z").getTime(),
        // let dumpData = [...this.state.orignalData];
        const { name, value } = e.target;
        let newtime = new Date(e.target.value);
        // let newtime = new Date(e.target.value).getTime();
        let result = [...this.state.orignalData];
        if (this.state.name) {
            const hotelregex = new RegExp(this.state.name, 'i');

            result = result.filter(function (datum) {
                return (datum.url.search(hotelregex) > -1);
            });
        }
        if (this.state.country) {
            const countryregex = new RegExp(this.state.country, 'i');
            result = result.filter(function (datum) {
                return (datum.country.search(countryregex) > -1);
            });
        }
        if (this.state.state) {
            const stateregex = new RegExp(this.state.state, 'i');
            result = result.filter(function (datum) {
                return (datum.state.search(stateregex) > -1);
            });
        }
        if (this.state.city) {
            const cityregex = new RegExp(this.state.city, 'i');
            result = result.filter(function (datum) {
                return (datum.city.search(cityregex) > -1);
            });
        }
        if (name == 'fromDate') {
            // let sd = new Date(e.target.value).getTime();
            if (value) result = result.filter(d => {
                var date = new Date(d.datetime);
                var d = date.getDate();
                var m = date.getMonth() + 1;
                var y = date.getFullYear();
                var dateString = y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
                var time = new Date(dateString);
                return this.state.toDate ? (newtime <= time && time <= "") : (newtime <= time);
                // return (sd < time && time < ed);
            });
            this.setState({
                historyData: result, fromDate: value, fromTime: newtime, toDate: "", hideReset: true
            });
        }

        if (name == 'toDate') {
            if (value) result = result.filter(d => {
                var date = new Date(d.datetime);
                var d = date.getDate();
                var m = date.getMonth() + 1;
                var y = date.getFullYear();
                var dateString = y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
                var time = new Date(dateString);
                return this.state.fromDate ? (this.state.fromTime <= time && time <= newtime) : (time <= newtime);
            });
            this.setState({
                historyData: result, toDate: value, toTime: newtime, hideReset: true
            });
        }
    }

    listAllHistory = () => {
        this.setState({ spinner: true });
        const account = this.props.AccountState.account;
        var dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + ' ' + (account.timeformat != '' ? account.timeformat : "hh:mm A")
        let uniqueData = JSON.parse(localStorage.getItem('historyData')) || []
        const uniqueUrl = [];
        const uniqueCity = [];
        const uniqueCountry = [];
        const uniqueState = [];
        var data = []
        if (uniqueData && uniqueData.length > 0) {
            uniqueData.map(history => {
                let url = history.url;
                if (url.search('www') > -1) url = url.replace("http://", '');
                else {
                    url = url.replace("http://", 'www.');
                    url = url.replace("https://", 'www.');
                }
                url = url.replace("/store.php", '');
                history.url = url.split('/')[0];

                if (uniqueUrl.indexOf(history.url) === -1) {
                    uniqueUrl.push(history.url);
                }
                if (uniqueCity.indexOf(history.city) === -1) {
                    uniqueCity.push(history.city);
                }
                if (uniqueCountry.indexOf(history.country) === -1) {
                    uniqueCountry.push(history.country);
                }
                if (uniqueState.indexOf(history.state) === -1) {
                    uniqueState.push(history.state);
                }

                // if (this.state.uniqueUrl.indexOf(history.url) === -1) {
                //     this.setState({ uniqueUrl: [...this.state.uniqueUrl, history.url] })
                // }
                // if (this.state.uniqueCity.indexOf(history.city) === -1) {
                //     this.setState({ uniqueCity: [...this.state.uniqueCity, history.city] })
                // }
                // if (this.state.uniqueCountry.indexOf(history.country) === -1) {
                //     this.setState({ uniqueCountry: [...this.state.uniqueCountry, history.country] })
                // }
                // if (this.state.uniqueState.indexOf(history.state) === -1) {
                //     this.setState({ uniqueState: [...this.state.uniqueState, history.state] })
                // }

                // ======================= Change time format =======================

                const utcMoment = moment.utc(history.datetime, 'YYYY-MM-DD HH:mm:ss');
                const chicagoMoment = utcMoment.tz('America/Chicago');
                const chicagoTimeFormatted = chicagoMoment.format(dtFormat);
                history.datetime = chicagoTimeFormatted
                data.push(history)
            });
        }
        this.setState({
            orignalData: data,
            historyData: data,
            counts: data.length,
            uniqueUrl: uniqueUrl,
            uniqueCity: uniqueCity,
            uniqueCountry: uniqueCountry,
            uniqueState: uniqueState,
            urlcount: uniqueUrl.length,
            citycount: uniqueCity.length,
            countrycount: uniqueCountry.length,
            statecount: uniqueState.length,
            spinner: false
        })
    }
    componentDidMount() {
        this.listAllHistory()
        //default scroll top the page
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    filterReset = async e => {
        this.gridApi.paginationGoToPage(0);
        this.setState({
            hotelName: "",
            fromDate: '',
            toDate: '',
            hotel: '',
            country: '',
            selectedState: "",
            searchhoteloption: "",
            selectedCountry: "",
            searchcountryoption: "",
            searchcityoption: "",
            searchstateoption: "",
            state: '',
            city: '',
            statusProgress: { label: "All", value: 0 },
            hideReset: false
        })
        this.listAllHistory()
    }

    render() {
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]
        const hotelOptions = [{ label: 'All', value: '', name: 'hotel' }];
        if (this.state.uniqueUrl) {
            this.state.uniqueUrl.map(data => {
                hotelOptions.push({ label: data, value: data, name: 'hotel' })
            })
        }
        const languageData = this.props.AccountState.account.SelectedlanguageData
        return (
            <>
                <div className="breadcrump">
                    <p> <Link to="/"><h6>{languageData && languageData.DASHBOARD ? languageData.DASHBOARD : "Dashboard"}</h6></Link>  <span><i className="fa fa-angle-right" aria-hidden="true"></i> </span>  <Link to="/booking-count"><h6 className="highlights_breadcrump">{languageData && languageData.BOOKING_COUNT ? languageData.BOOKING_COUNT + " List" : "Booking Count List"} </h6></Link></p>
                </div>
                <div className="section-body history pt-3">
                    <div className="container-fluid">
                        <div className="row clearfix common_top_section">
                            <div className="col-6 col-md-6 col-xl-3">
                                <div className="card">
                                    <div className="card-body ribbon">
                                        <div className="ribbon-box orange">{this.state.counts}</div>
                                        <p className="my_sort_cut_1 text-muted" >
                                            <span className='his_icon'><i className="icon-list"></i></span><br></br>
                                            <span className='his_total'>Booking Count</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-xl-3">
                                <div className="card">
                                    <div className="card-body ribbon">
                                        <div className="ribbon-box orange">{this.state.urlcount}</div>
                                        <p className="my_sort_cut_1 text-muted" >
                                            <span className='his_icon'><i className="fa fa-building-o"></i></span><br></br>
                                            <span className='his_total'> Hotel</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-xl-3">
                                <div className="card">
                                    <div className="card-body ribbon">
                                        <div className="ribbon-box orange">{this.state.citycount}</div>
                                        <p className="my_sort_cut_1 text-muted">
                                            <span className='his_icon'><i className="fa fa-copyright"></i></span><br></br>
                                            <span className='his_total'>Cities</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-xl-3">
                                <div className="card">
                                    <div className="card-body ribbon">
                                        <div className="ribbon-box orange">{this.state.countrycount}</div>
                                        <p className="my_sort_cut_1 text-muted" href="#">
                                            <span className='his_icon'><i className="fa fa-globe"></i></span><br></br>
                                            <span className='his_total'>Countries</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className={`section-body`}>
                            <div className="container-fluid">
                                <div className="d-flex justify-content-between align-items-center">
                                    <ul className="nav nav-tabs page-header-tab">
                                    </ul>
                                    <div className="page-header" style={{ marginTop: '5px' }}>
                                        <div className="right">
                                            <ul className="nav nav-pills">
                                                <li className="nav-item dropdown" style={{ background: '#be7b08' }}>
                                                    <a style={{ color: '#fff' }} className="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2" aria-hidden="true"></i>Export</a>
                                                    <div className="dropdown-menu">
                                                        <a className="dropdown-item" onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                        <a className="dropdown-item" onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="Departments-list" role="tabpanel">
                                <div className="card">
                                    <div className="card-header tit_res">
                                        <div className='d-flex'>
                                            <div className='rounded_icon'><i className="icon-list mr-2"></i></div>
                                            <div className='d-flex align-items-center'>
                                                <h3 className="card-title"> {languageData && languageData.BOOKING_COUNT ? languageData.BOOKING_COUNT + " List" : "Booking Count List"}</h3>
                                            </div>
                                        </div>

                                        <div className="card-options ">
                                            <div className="page-header">
                                                <div className="right">
                                                    {(this.state.historyData).length > 0 ? <>
                                                        <a className="btn btn-primary btn-sm nav-link dropdown-toggle export_btn_grid ml-0" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2 " aria-hidden="true"></i>Export</a>
                                                        <div className="dropdown-menu">
                                                            <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                            <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                        </div>
                                                    </> : []}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        {this.state.orignalData.length > 0 ?
                                            <div className="row">
                                                <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3">
                                                    <label className="form-label">{languageData && languageData.SEARCH ? languageData.SEARCH : "Search"}  {languageData && languageData.HOTEL ? languageData.HOTEL : "Hotel"}</label>
                                                    <div className="form-group mb-0">
                                                        {/* <input type="text" className="form-control" name="hotel" placeholder="Search Hotel..."
                                                        onChange={this.onChange} /> */}
                                                        <Select
                                                            name='hotel'
                                                            // className="form-control"
                                                            onChange={this.handleChange}
                                                            options={hotelOptions}
                                                            value={this.state.searchhoteloption ? { label: this.state.searchhoteloption.label } : ''}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3">
                                                    <label className="form-label">{languageData && languageData.COUNTRY ? languageData.COUNTRY : "Country"}</label>
                                                    <div className="form-group mb-0">
                                                        <Select
                                                            value={this.state.searchcountryoption ? { label: this.state.searchcountryoption.label } : ''}
                                                            onChange={this.handleChange}
                                                            options={this.state.selectedCountry ? this.state.selectedCountry.map(data => {
                                                                return { label: data, value: data, name: 'country' }
                                                            }) : this.state.uniqueCountry.map(data => {
                                                                return { label: data, value: data, name: 'country' }
                                                            })
                                                            }
                                                        />
                                                        {/* <select name="country" className="form-control" onChange={this.onChange} >
                                                            <option value='' selected={this.state.country == ''}>Select Country</option>
                                                            {this.state.name ?
                                                                this.state.selectedCountry.map((value, i) => {
                                                                    return <option key={i} value={value}>{value}</option>
                                                                })
                                                                :
                                                                this.state.uniqueCountry.map((value, i) => {
                                                                    return <option key={i} value={value}>{value}</option>
                                                                })
                                                            }

                                                        </select> */}
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3">
                                                    <label className="form-label">{languageData && languageData.STATE ? languageData.STATE : "State"}</label>
                                                    <div className="form-group mb-0">
                                                        <Select
                                                            value={this.state.searchstateoption ? { label: this.state.searchstateoption.label } : ''}
                                                            onChange={this.handleChange}
                                                            options={this.state.country ? this.state.selectedState.map(data => {
                                                                return { label: data, value: data, name: 'state' }
                                                            }) : this.state.uniqueState.map(data => {
                                                                return { label: data, value: data, name: 'state' }
                                                            })
                                                            }
                                                        />
                                                        {/* <select name="state" className="form-control" onChange={this.onChange} >
                                                            <option value='' selected={this.state.state == ''}>Select State</option>
                                                            {this.state.country ?
                                                                this.state.selectedState.map((value, i) => {
                                                                    return <option key={i} value={value}>{value}</option>
                                                                })
                                                                :
                                                                this.state.uniqueState.map((value, i) => {
                                                                    return <option key={i} value={value}>{value}</option>
                                                                })
                                                            }

                                                        </select> */}
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3">
                                                    <label className="form-label">{languageData && languageData.CITY ? languageData.CITY : "City"}</label>
                                                    <div className="form-group mb-0">
                                                        <Select
                                                            value={this.state.searchcityoption ? { label: this.state.searchcityoption.label } : ''}
                                                            name='hotel'
                                                            // className="form-control"
                                                            onChange={this.handleChange}
                                                            options={this.state.selectedCity.map(data => {
                                                                return { label: data, value: data, name: 'city' }
                                                            })}
                                                        />
                                                        {/* <select name="city" className="form-control" onChange={this.onChange} >
                                                            <option value='' selected={this.state.city == ''}>Select City</option>
                                                            {this.state.selectedCity.map((value, i) => {
                                                                return <option key={i} value={value}>{value}</option>
                                                            })}
                                                        </select> */}
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3 pt-3">
                                                    <label className="form-label" >{languageData && languageData.LIMIT ? languageData.LIMIT : "Limit"}</label>
                                                    <div className="form-group mb-0">
                                                        <Select
                                                            onChange={(e) => this.gridApi.paginationSetPageSize(Number(e.value))}
                                                            options={limitOptions}
                                                            defaultValue={limitOptions[0]}
                                                            className='limit_size'
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3 pt-3">
                                                    <label className="form-label">{languageData && languageData.FROM ? languageData.FROM : "From"} {languageData && languageData.DATE ? languageData.DATE : "Date"}</label>
                                                    <div className='site_pass_calander'>
                                                        <input type='date' className="form-control" name="fromDate" value={this.state.fromDate} onChange={this.setDate}></input>
                                                        <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3 pt-3">
                                                    <label className="form-label">{languageData && languageData.TO ? languageData.TO : "To"} {languageData && languageData.DATE ? languageData.DATE : "Date"}</label>
                                                    <div className='site_pass_calander'>
                                                        <input type='date' className="form-control" name="toDate" min={this.state.fromDate ? this.state.fromDate : ''} onChange={this.setDate} value={this.state.toDate}></input>
                                                        <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                    </div>
                                                </div>
                                                {this.state.hideReset ?
                                                    <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3 d-flex align-items-end mb-3">
                                                        <button className='btn social_rest_btn btn-primarys' type='button' onClick={this.filterReset}><i class="fa fa-refresh" aria-hidden="true" style={{ fontSize: '20px !importent', marginRight: '7px' }}></i> Reset</button>
                                                    </div> : ''}
                                            </div> : ""}

                                        <div className="table-responsive pt-3">
                                            <div className="ag-theme-alpine">
                                                <AgGridReact
                                                    rowHeight={82}
                                                    paginationPageSize={25}
                                                    pagination={true}
                                                    domLayout={"autoHeight"}
                                                    defaultColDef={this.state.defaultColumDef}
                                                    rowData={this.state.historyData}
                                                    onGridReady={this.onGridReady}
                                                    columnDefs={this.state.columnDefs}
                                                    rowDragManaged={true}
                                                    animateRows={true}
                                                    overlayNoRowsTemplate={"No rows to display"}
                                                >
                                                </AgGridReact>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="overlay" style={{ display: this.state.spinner ? 'block' : 'none' }}></div>
                {this.state.spinner ?
                    <div className='common_loader'>
                        <img className='loader_img_style_common' src='../../assets/images/load.png' />
                        <Spinner className='spinner_load_common' animation="border" variant="info" >
                        </Spinner>
                    </div>
                    : ""}
            </>
        )
    }
}
const mapStateToProps = state => ({
    fixNavbar: state.settings.isFixNavbar,
    AccountState: state.account,
})

const mapDispatchToProps = dispatch => ({})
export default connect(mapStateToProps, mapDispatchToProps)(ListHistory);